import { useEffect, useState } from "react";
import { CARD_FIELD_TYPE } from "../data/interfaces";

export default function useCardFieldsOrder(order: string[] = [], card_fields: any = {}): string[] {
    const [_order, set_order] = useState<string[]>([])
    useEffect(() => {
        const keys: string[] = Object.keys(card_fields)
        let o: string[] = []
        if( keys[0] === CARD_FIELD_TYPE.EMPTY) {
            o.push( CARD_FIELD_TYPE.EMPTY )
        }
        order.forEach((ord, i) => {
            o.push( ord )
            const curIndex = keys.findIndex(key => key === ord )
            if( keys[curIndex + 1] === CARD_FIELD_TYPE.EMPTY && curIndex + 1 < o.length - 1 ) {
                o.push( CARD_FIELD_TYPE.EMPTY ) 
            }
        })
        if( keys[keys.length - 1] === CARD_FIELD_TYPE.EMPTY && o[o.length - 1] !== CARD_FIELD_TYPE.EMPTY ) {
            o.push( CARD_FIELD_TYPE.EMPTY )
        }
        set_order( o )
    },[])
    return _order
}